import { SvgIcon } from '../enums/svg-icon';

export enum BannerTypeEnum {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning'
}

export const BannerIcons: Record<BannerTypeEnum, string> = {
  [BannerTypeEnum.ERROR]: SvgIcon.ErrorRed,
  [BannerTypeEnum.INFO]: SvgIcon.InfoBlue,
  [BannerTypeEnum.SUCCESS]: SvgIcon.SuccessGreen,
  [BannerTypeEnum.WARNING]: SvgIcon.WarningBlack
};

export interface BannerType {
  type: BannerTypeEnum;
}

export interface BannerConfig {
  category?: string;
  hyperlink?: {
    route: string;
    text: string;
  };
  icon: string;
  id: string;
  message: string;
  title?: string;
  type: BannerType;
  sendDate?: string;
  endDate?: string;
}
